import { render, staticRenderFns } from "./BaseSkeleton.vue?vue&type=template&id=1a216b1f&scoped=true&"
import script from "./BaseSkeleton.vue?vue&type=script&lang=js&"
export * from "./BaseSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./BaseSkeleton.vue?vue&type=style&index=0&id=1a216b1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a216b1f",
  null
  
)

export default component.exports